module.exports = __webpack_public_path__ + "static/media/Simon Breslav.0ef13e42.png";